import { Component } from "react"
import Popup from "../common/Popup"
import { showToast, TOAST_TYPE, DKButton, showLoader, removeLoader, DKIcons, DKLabel, DKIcon, DKSpinner, DKTooltipWrapper, DKInput, Toggle } from "deskera-ui-library";

import Places from "../google-map/Places";
import i18next from "i18next";
export default class MapPopup extends Component {
  latLong
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    this.setState({
      ...this.state
    })
  }
  onClose() {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }
  onSelectAddress(data) {
    this.latLong = data
  }
  onSave() {
    if (this.props.onClose) {
      this.props.onClose(this.latLong)
    }
  }
  render() {
    return (
      <Popup popupClass={"map-popup"}>
        <div className="row justify-content-between pt-xl p-h-xl">
          <DKLabel className="fw-m fs-l" text={i18next.t("SELECT_LOCATION")} />
          <div className="d-flex">
            <DKButton title={i18next.t("SAVE")} className="bg-app  text-white " onClick={() => this.onSave()} />
            <DKButton title={i18next.t("CANCEL")} className=" border-m bg-gray1  ml-m" onClick={() => this.onClose()} />
          </div>

        </div>
        <div className="parent-width google_maps mt-l" style={{
          minHeight: 600
        }}>
          <Places latLng={this.props.data?.rowData?.coordinatesList} onSelectAddress={(location) => this.onSelectAddress(location)} />
        </div>
      </Popup>
    )
  }
}